/* CUSTOM: collection filter tiles
 *
 * Clicking a tile filters the current collection in place by product type. Rather than
 * fetching products itself, it hands the filtered URL to Warehouse's own collection code
 * (the [data-action="clear-filters"] handler, which reloads the grid from data-url). So the
 * grid, pagination, sorting, sidebar filters and URL all stay in the theme's hands.
 */
(function () {
  if (window.__dblnFilterTilesInit) return;
  window.__dblnFilterTilesInit = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function currentTypes() {
    return new URL(window.location.href).searchParams.getAll('filter.p.product_type').sort();
  }

  function sync(root) {
    var active = currentTypes().join('|');
    root.querySelectorAll('[data-filter-tile]').forEach(function (tile) {
      var types = JSON.parse(tile.getAttribute('data-types') || '[]').sort().join('|');
      if (active && types === active) tile.setAttribute('aria-current', 'true');
      else tile.removeAttribute('aria-current');
    });
    var reset = root.querySelector('[data-filter-tiles-reset]');
    if (reset) reset.hidden = !active;
  }

  function apply(root, types) {
    // Build the new URL (only the product type filter, plus the current sort order and
    // template view), then hand it to the theme through its own "clear filters" action,
    // which loads whatever URL is in data-url and reloads the grid in place.
    var current = new URL(window.location.href);
    var next = new URL(window.location.pathname, window.location.origin);
    ['sort_by', 'view'].forEach(function (key) {
      if (current.searchParams.get(key)) next.searchParams.set(key, current.searchParams.get(key));
    });
    types.forEach(function (type) { next.searchParams.append('filter.p.product_type', type); });

    var trigger = root.querySelector('[data-filter-tiles-trigger]');
    if (!trigger) {
      trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.hidden = true;
      trigger.tabIndex = -1;
      trigger.setAttribute('data-action', 'clear-filters');
      trigger.setAttribute('data-filter-tiles-trigger', '');
      root.appendChild(trigger);
    }

    trigger.setAttribute('data-url', next.pathname + next.search);
    root.classList.add('is-filtering');
    trigger.click();
  }

  function animateGrid() {
    if (reduceMotion) return;
    var grid = document.querySelector('.collection__dynamic-part .product-list');
    if (!grid || !grid.animate) return;
    grid.animate(
      [{ opacity: 0, transform: 'translateY(16px)' }, { opacity: 1, transform: 'translateY(0)' }],
      { duration: 350, easing: 'ease-out' }
    );
  }

  function init(root) {
    if (root.__dblnInit) return;
    root.__dblnInit = true;

    root.addEventListener('click', function (event) {
      var tile = event.target.closest('[data-filter-tile]');
      var reset = event.target.closest('[data-filter-tiles-reset]');
      if (!tile && !reset) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) return; // let "open in new tab" work

      event.preventDefault();

      if (reset || tile.getAttribute('aria-current') === 'true') {
        apply(root, []);
        var first = root.querySelector('[data-filter-tile]');
        if (reset && first) first.focus(); // the reset link hides itself, so keep focus nearby
      } else {
        apply(root, JSON.parse(tile.getAttribute('data-types') || '[]'));
      }
    });

    sync(root);
  }

  function initAll() {
    document.querySelectorAll('[data-filter-tiles]').forEach(init);
  }

  // The theme fires these around every grid reload (tiles, sidebar filters, sorting, pages).
  document.addEventListener('theme:loading:end', function () {
    document.querySelectorAll('[data-filter-tiles]').forEach(function (root) {
      if (root.classList.contains('is-filtering')) {
        root.classList.remove('is-filtering');
        animateGrid();
      }
      sync(root);
    });
  });

  window.addEventListener('popstate', function () {
    document.querySelectorAll('[data-filter-tiles]').forEach(sync);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();
